<template>
  <router-view v-if="!initialNavigationPending" />
  <div v-else class="app-shell-fallback" aria-live="polite" aria-busy="true">
    <div class="app-shell-fallback__pulse" />
  </div>
</template>

<script setup>
import { initialNavigationPending } from '@/router';
</script>

<style scoped>
.app-shell-fallback {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #f8fafc 0%, #eef2ff 100%);
}

.app-shell-fallback__pulse {
  width: min(220px, calc(100vw - 48px));
  height: 14px;
  border-radius: 999px;
  background: linear-gradient(90deg, rgba(148, 163, 184, 0.18), rgba(99, 102, 241, 0.32), rgba(148, 163, 184, 0.18));
  background-size: 200% 100%;
  animation: pulse 1.2s ease-in-out infinite;
}

@keyframes pulse {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
</style>
